// extracted by mini-css-extract-plugin
module.exports = {"innerWrapper":"uC","tooltipWrapper":"vC","icon":"wC","tooltip":"xC","content":"yC"};